module.exports = __webpack_public_path__ + "img/待审核.d2729496.svg";